import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetVacancyHistory = {
  getVacancyHistory: { data: null, loading: false, error: null },
};

const isAppendRequest = (arg) => {
  if (typeof arg !== 'object' || !arg) {
    return false;
  }

  if (arg?.url) {
    return true;
  }

  const page = Number(arg?.page);
  return Number.isFinite(page) && page > 1;
};

export const getVacancyHistory = createAsyncThunk('user/getVacancyHistory', async (payload, { rejectWithValue, fulfillWithValue }) => {
  const id = typeof payload === 'object' ? payload?.id : payload;
  const url = typeof payload === 'object' ? payload?.url : null;
  const page = typeof payload === 'object' ? Number(payload?.page) : null;
  const requestUrl = url || `/vacancies/${id}/history`;
  const requestConfig = {
    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
  };

  if (!url && Number.isFinite(page) && page > 0) {
    requestConfig.params = { page };
  }

  return await axiosInstance
    .get(requestUrl, requestConfig)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetVacancyHistory = {
  [getVacancyHistory.pending]: (state, action) => {
    if (!isAppendRequest(action.meta.arg)) {
      state.getVacancyHistory.data = null;
    }
    state.getVacancyHistory.loading = true;
    state.getVacancyHistory.error = null;
  },
  [getVacancyHistory.fulfilled]: (state, action) => {
    const isAppend = isAppendRequest(action.meta.arg);
    state.getVacancyHistory.loading = false;
    if (isAppend && state.getVacancyHistory.data) {
      state.getVacancyHistory.data = {
        ...action.payload,
        results: [...(state.getVacancyHistory.data?.results || []), ...(action.payload?.results || [])],
      };
    } else {
      state.getVacancyHistory.data = action.payload;
    }
    state.getVacancyHistory.error = null;
  },
  [getVacancyHistory.rejected]: (state, action) => {
    state.getVacancyHistory.loading = false;
    state.getVacancyHistory.error = action.payload;
  },
};
